import { render, staticRenderFns } from "./CompaniesIcon.vue?vue&type=template&id=6b6d5582"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6d5582')) {
      api.createRecord('6b6d5582', component.options)
    } else {
      api.reload('6b6d5582', component.options)
    }
    module.hot.accept("./CompaniesIcon.vue?vue&type=template&id=6b6d5582", function () {
      api.rerender('6b6d5582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CompaniesIcon.vue"
export default component.exports